<template>
  <section class="search-module-section">
    <slot name="configure" />

    <SearchFilterPageTemplate
      ref="searchFilterPageTemplate"
      :job-search-global="module"
      :computed-function="computedFunction"
      :style="modulePadding"
      :search-tablist-aria-label="searchTablistAriaLabel"
      :toggle-map-view-aria-label="toggleMapViewAriaLabel"
      :toggle-list-view-aria-label="toggleListViewAriaLabel"
      @filter-clicked="$emit('filter-clicked', $event)"
      @view-changed="$emit('view-changed', $event)"
    >
      <template #search-box>
        <slot name="search-box" />
      </template>

      <template #filter-list="{ filter }">
        <slot name="filter-list" :filter="filter" />
      </template>

      <template #filter-location="{ filter }">
        <slot name="filter-location" :filter="filter" />
      </template>

      <template #filter-select="{ filter }">
        <slot name="filter-select" :filter="filter" />
      </template>

      <template #filter-slider="{ filter }">
        <slot name="filter-slider" :filter="filter" />
      </template>

      <template #single-filter-reset="{ filter }">
        <slot name="single-filter-reset" :filter="filter" />
      </template>

      <template #results-loading>
        <slot name="results-loading" />
      </template>

      <template #stats>
        <slot name="stats" />
      </template>

      <template #sorting-select>
        <slot name="sorting-select" />
      </template>

      <template #all-filter-reset>
        <slot name="all-filter-reset" />
      </template>

      <template #results>
        <slot name="results" />
      </template>

      <template #empty-state>
        <slot name="empty-state" />
      </template>

      <template #map-view>
        <slot name="map-view" />
      </template>
    </SearchFilterPageTemplate>
  </section>
</template>

<script>
import SearchFilterPageTemplate from "../SearchFilterPageTemplate/SearchFilterPageTemplate.vue";
import searchAndFilterModule from "./searchAndFilterModuleDefaultProp.js";
import { globalComputed } from "../../GlobalUI/mixins/global.js";

export default {
  name: "SearchAndFilterModule",
  components: {
    SearchFilterPageTemplate,
  },
  mixins: [globalComputed],
  props: {
    module: {
      type: Object,
      default() {
        return searchAndFilterModule;
      },
    },
    computedFunction: {
      type: Function,
      required: true,
    },
    searchTablistAriaLabel: {
      type: String,
      required: true,
      default: "Search View Toggle Buttons",
    },
    toggleMapViewAriaLabel: {
      type: String,
      required: true,
      default: "Toggle Map View",
    },
    toggleListViewAriaLabel: {
      type: String,
      required: true,
      default: "Toggle List View",
    },
  },
  emits: ["filter-clicked", "view-changed"],
};
</script>

<style lang="scss" scoped>
:deep(.search-filter-main-wrapper) {
  padding-bottom: 0;
}

:deep(.search-filter-filter-pane) {
  padding-top: 0;
}
</style>
